import React from "react";
import classes from "./Avatar.module.css";

export const AVATAR_MAX_VISIBLE = 7;

const Avatar = ({ color, initials, title, size = 28, isOverflow = false, overflowCount, className = "" }) => {
    const bgColor = isOverflow ? "#342d5a" : color;

    return (

        <div
            className={`${classes.Avatar} ${className}`}
            style={{ backgroundColor: bgColor, width: size, height: size }}
            title={title}
        >
            {isOverflow ? (
                <span className={classes.OverflowText}>+{overflowCount}</span>
            ) : (
                <span className={classes.Initials}>{initials}</span>
            )}
        </div>
    );
};

export default Avatar;
